// src/components/Admin/ItemManager/ConfirmMemoModal.jsx
// 처리 메모 + 처리 유형 선택 모달
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Button, FormControl, InputLabel, Select, MenuItem,
} from '@mui/material';
import { useState, useEffect } from 'react';

export default function ConfirmMemoModal({
  open,
  onClose,
  onSubmit,
  initialMemo = '',
  isEditing = false,
}) {
  const [memo, setMemo] = useState('');
  const [actionType, setActionType] = useState('approve'); // approve | refund

  useEffect(() => {
    setMemo(initialMemo || '');
    setActionType('approve');
  }, [initialMemo, open]);

  const handleSubmit = () => {
    onSubmit(memo, actionType);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      sx={{
        '& .MuiDialog-paper': {
          /* 모바일: 90 % 축소 & 좌상단 기준 */
          '@media (max-width:600px)': {
            transform: 'scale(0.9)',
            transformOrigin: 'top left',
          },
        },
      }}
    >
      <DialogTitle>{isEditing ? '메모 수정' : '처리 메모 입력'}</DialogTitle>

      <DialogContent sx={{ pt: 2 }}>
        {!isEditing && (
          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel id="action-type-label">처리 유형</InputLabel>
            <Select
              labelId="action-type-label"
              value={actionType}
              label="처리 유형"
              onChange={(e) => setActionType(e.target.value)}
            >
              <MenuItem value="approve">승인</MenuItem>
              <MenuItem value="refund">환불</MenuItem>
            </Select>
          </FormControl>
        )}

        <TextField
          fullWidth
          multiline
          minRows={3}
          label="메모 (선택 입력)"
          value={memo}
          onChange={(e) => setMemo(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault();
              handleSubmit();
            }
          }}
          sx={{
            mt: 2,
            '@media (max-width:600px)': { fontSize: '0.85rem' },
          }}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>취소</Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          sx={{ '@media (max-width:600px)': { fontSize: '0.8rem', px: 1.6 } }}
        >
          {isEditing ? '수정' : '처리'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
